import React from 'react';
import {parseMessage} from 'lib/stringHelper';
import {FmlxCheckBox} from 'fmlx-common-ui';
import {getStepNameSelector} from 'stores/selectors/wizardSelectors';
import {isEmpty} from 'lodash';

import FormattedHTMLMessage from '../../components/FormattedHTMLMessage';
import {resolveIntl, setErrorCodeNumber} from './commonBusiness';
import {
  showModal,
  hideModal,
  setModalInvalid,
  setModalValid,
  setModalContent,
  clearModalError,
} from '../actions/modalStateAction';
import {hideLoading, changeView, showLoading} from '../actions/appStateAction';
import {setInstrumentHubSignalR} from '../actions/signalrStateAction';
import {
  ViewMode,
  SignalREvent,
  GetAllMotorStatusMotorErrorStatus,
  MotorName,
  FastRobotErrorcode,
  RuntimeMode,
  ModalSize,
  CommonButtonLabel,
  FastRobotStatusCode,
} from '../../constants/dataEnum';
import {resetPlateTypeEditorState} from '../actions/plateTypeEditorStateAction';
import {showLicenseModal} from '../actions/licenceStateAction';
import {getLicenseData} from './licenseBusiness';
// eslint-disable-next-line import/no-cycle
import {
  getAllMotorStatus,
  getMaxTipClampConfig,
  getTipClampStatistic,
  isTouchProbeExpanded,
  moveToIdlePosition,
  safeTouchProbeExtend,
  safeTouchProbeRetract,
  setLEDIndicator,
} from './instrumentBusiness';
import MessageBox, {getMessageBoxActionButtons} from '../../components/MessageBox';
import {addTemporaryState, removeTemporaryState} from '../actions/temporaryStateAction';
import {isUserOperator} from './userManagementBusiness';
import TouchProbeGuideImage from '../../components/TouchProbeGuideImage';
import {setWizardFlag} from '../actions/wizardStateAction';
import {showConfirmationModal, showModalSimplified} from './commonModalBusiness';
import {A1OffsetCalibrationSubstep, SetupWizardStep, WizardFlag} from '../../constants/SetupWizardEnum';
import {getSetupWizardCurrentStepData} from './setupWizardBusiness/commonSetupWizardBusiness';
import {isV2Instrument} from './instrumentStatusBusiness';

const intl = resolveIntl();

/**
 * Shows missing tray modal for entering (any) calibration page
 */
export function showModalInvalidDeck() {
  return (dispatch, getState) => {
    const {appState, signalrState} = getState();
    const {viewMode} = appState;
    dispatch(addTemporaryState('errorModal', {errorCode: FastRobotErrorcode.MissingTray}));

    dispatch(
      showModal(
        intl.formatMessage({
          id: 'trayCalibrationContainer.modal.missingTrayCalibration.title',
        }),
        <FormattedHTMLMessage id="trayCalibrationContainer.modal.missingTrayCalibration.text" />,
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: () => {
              dispatch(hideModal());
              const {instrumentControlHub} = signalrState;

              if (instrumentControlHub) {
                instrumentControlHub.stop().then(() => {
                  console.log('TrayCalibrationContainer -> instrumentControlHub connection stopped.');
                });
              }

              if (viewMode !== ViewMode.LABWARE_MANAGER && viewMode !== ViewMode.SETUP_WIZARD) {
                dispatch(changeView(ViewMode.EXPLORER));
              }

              dispatch(setInstrumentHubSignalR(null));
              dispatch(resetPlateTypeEditorState());
            },
            text: intl.formatMessage({
              id: 'trayCalibrationContainer.modal.missingTrayCalibration.firstButton',
            }),
          },
        ],
        () => {
          if (viewMode !== ViewMode.LABWARE_MANAGER) {
            dispatch(changeView(ViewMode.EXPLORER));
          }

          dispatch(setInstrumentHubSignalR(null));
          dispatch(hideModal());
          dispatch(resetPlateTypeEditorState());
        },
        'invalidDeckModal',
        false,
      ),
    );
  };
}

export function showMotorMoveErrorInvalidValue(response) {
  return (dispatch) => {
    dispatch(
      showModal(
        intl.formatMessage({
          id: 'modal.motorMoveInvalidValueMessage.title',
        }),
        <FormattedHTMLMessage id="modal.motorMoveInvalidValueMessage.text" values={{errorCode: response}} />,
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: () => {
              dispatch(hideModal());
            },
            text: intl.formatMessage({
              id: 'modal.motorMoveInvalidValueMessage.firstButton',
            }),
          },
        ],
        () => {
          dispatch(hideModal());
        },
      ),
    );
  };
}

// #region touch probe

export const showTouchProbeCollisionModal =
  (firstButtonCallback, secondButtonCallback, fastRecovery) => (dispatch, getState) => {
    const {appState, wizardState} = getState();
    const {stepName} = wizardState;
    let idTextModal = '';

    if (
      appState.viewMode === ViewMode.TRAY_CALIBRATION ||
      (appState.viewMode === ViewMode.SETUP_WIZARD && stepName === SetupWizardStep.TRAY_CALIBRATION)
    ) {
      idTextModal = 'trayCalibrationContainer.modal.touchProbeCollisionConfirmation';
    } else if (
      appState.viewMode === ViewMode.PLATE_TYPE_EDITOR ||
      (appState.viewMode === ViewMode.SETUP_WIZARD && stepName === SetupWizardStep.PLATE_DEFINITION)
    ) {
      idTextModal = 'plateTypeEditorContainer.modal.touchProbeCollisionConfirmation';
    }

    dispatch(
      showModal(
        intl.formatMessage({id: 'modal.touchProbeCollision.title'}),
        <FormattedHTMLMessage id="modal.touchProbeCollision.text" />,
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: async () => {
              dispatch(hideModal());
              await dispatch(fastRecovery());
              if (secondButtonCallback) {
                dispatch(showConfirmationModal(idTextModal, firstButtonCallback, secondButtonCallback));
              } else {
                firstButtonCallback();
              }
            },
            text: intl.formatMessage({id: 'modal.touchProbeCollision.firstButton'}),
          },
        ],
        () => {},
        '',
        true,
      ),
    );
  };

export function showModalTouchProbeRetractFailed() {
  return (dispatch) => {
    dispatch(
      showModal(
        intl.formatMessage({
          id: 'modal.touchProbeRetractFailed.title',
        }),
        <FormattedHTMLMessage id="modal.touchProbeRetractFailed.text" />,
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: () => {
              dispatch(hideModal());
            },
            text: intl.formatMessage({
              id: 'modal.touchProbeRetractFailed.firstButton',
            }),
          },
        ],
        () => {
          // dispatch(hideModalSetTrayID());
          dispatch(hideModal());
        },
        '',
        false,
      ),
    );
  };
}

export function showModalTouchProbeExtendFailed(
  counter = 0,
  successCallback = () => {},
  errorCallback = () => {},
  abortCallback = () => {},
  isTouchProbeExtendedParam = true,
  isNoOptionSelected = true,
) {
  return (dispatch, getState) => {
    let isTouchProbeExtended = isTouchProbeExtendedParam;

    const toggleChoices = (isExtended) => {
      if (isNoOptionSelected) {
        dispatch(
          showModalTouchProbeExtendFailed(counter, successCallback, errorCallback, abortCallback, isExtended, false),
        );
      } else {
        isTouchProbeExtended = isExtended;
      }
    };

    const processOption = async () => {
      dispatch(hideModal());
      let response;

      if (isTouchProbeExtended) {
        response = await dispatch(safeTouchProbeExtend(0, true));
      } else {
        response = await dispatch(safeTouchProbeExtend(counter, false));
      }

      if (response === FastRobotErrorcode.NoError) {
        dispatch(removeTemporaryState('touchProbeExtendFailed'));
        successCallback(response);
      } else {
        await dispatch(addTemporaryState('touchProbeExtendFailed', {counter}));
        dispatch(errorCallback(response, successCallback));
      }
    };

    dispatch(
      showModal(
        intl.formatMessage({
          id: 'modal.touchProbeExtendFailed.title',
        }),
        <div>
          <FormattedHTMLMessage id="modal.touchProbeExtendFailed.text" />
          <TouchProbeGuideImage onToggle={toggleChoices} />
        </div>,
        [
          {
            className: 'btn-lg',
            style: 'primary',
            disabled: isNoOptionSelected,
            handlerClick: () => processOption(),
            text: intl.formatMessage({
              id: 'modal.touchProbeExtendFailed.firstButton',
            }),
          },
          {
            className: 'btn-lg',
            style: 'secondary',
            type: 'danger',
            variant: 'plain',
            handlerClick: async () => {
              const {appState, wizardState} = getState();

              await dispatch(hideModal());

              if (
                appState.viewMode === ViewMode.PLATE_TYPE_EDITOR ||
                wizardState.stepName === SetupWizardStep.PLATE_DEFINITION
              ) {
                const isTouchProbeExtendedResponse = await dispatch(isTouchProbeExpanded());

                await dispatch(moveToIdlePosition());

                if (isTouchProbeExtendedResponse) {
                  await dispatch(clearModalError());
                  // show touch probe retract confirmation

                  await dispatch(
                    showModalAutoCalibrationConfirmation(async () => {
                      dispatch(showLoading());
                      await dispatch(safeTouchProbeRetract());
                      await dispatch(hideLoading());

                      await dispatch(hideModal());
                      abortCallback();
                    }, SignalREvent.SAFE_TOUCH_PROBE_RETRACT),
                  );
                  return;
                }
              }

              abortCallback();
            },
            text: intl.formatMessage({
              id: 'modal.touchProbeExtendFailed.secondButton',
            }),
          },
        ],
        () => {
          dispatch(hideModal());
        },
        'auto-width',
        true,
        ModalSize.EXTRA_LARGE,
      ),
    );
  };
}

export function showModalTouchProbeNotWorkingProperly(errorCallback = () => {}) {
  return (dispatch, getState) => {
    const {appState} = getState();
    const {viewMode} = appState;
    dispatch(
      showModal(
        intl.formatMessage({
          id: 'modal.touchProbeNotWorkingProperly.title',
        }),
        <FormattedHTMLMessage id="modal.touchProbeNotWorkingProperly.text" />,
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: async () => {
              dispatch(hideModal());
              const response = await dispatch(safeTouchProbeRetract());

              if (response !== FastRobotErrorcode.NoError) {
                dispatch(errorCallback(response));
              }

              if (viewMode === ViewMode.SETUP_WIZARD) {
                dispatch(setWizardFlag(WizardFlag.ERROR));
              }
            },
            text: intl.formatMessage({
              id: 'modal.touchProbeNotWorkingProperly.firstButton',
            }),
          },
        ],
        () => {
          dispatch(hideModal());
        },
        '',
        true,
      ),
    );
  };
}

export const showModalTouchProbeExtendedEnterAutomatically = (callback) => (dispatch) => {
  const getContent = (isChecked) => {
    const onChangeHandler = (e) => {
      dispatch(setModalContent(getContent(e.target.checked)));

      if (e.target.checked) {
        dispatch(setModalValid());
      } else {
        dispatch(setModalInvalid());
      }
    };

    return (
      <div>
        <FormattedHTMLMessage id="modal.touchProbeExtendedEnterAutomatically.text" />
        <FmlxCheckBox
          onChange={onChangeHandler}
          label={intl.formatMessage({
            id: 'modal.touchProbeExtendedEnterAutomatically.labelCheckBox',
          })}
          checked={isChecked}
        />
      </div>
    );
  };

  dispatch(setModalInvalid());

  dispatch(
    showModal(
      intl.formatMessage({
        id: 'modal.touchProbeExtendedEnterAutomatically.title',
      }),
      getContent(false),
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: async () => {
            await dispatch(hideModal());
            dispatch(showLoading());
            await dispatch(safeTouchProbeRetract());
            dispatch(hideLoading());
            if (callback) callback();
          },
          text: intl.formatMessage({
            id: 'modal.touchProbeExtendedEnterAutomatically.firstButton',
          }),
        },
      ],
      () => {},
      '',
      true,
    ),
  );
};

export const checkIsTouchProbeExtendedWithModal =
  (callback, shouldTouchProbeExpanded = null, shouldSetLEDIndicator = false) =>
  async (dispatch) => {
    const isTouchProbeExpandedResponse = await dispatch(isTouchProbeExpanded());

    if (isTouchProbeExpandedResponse) {
      await dispatch(setErrorCodeNumber(FastRobotErrorcode.TouchProbeExpanded));
      await dispatch(showModalTouchProbeExtendedEnterAutomatically());

      if (shouldSetLEDIndicator) dispatch(setLEDIndicator(FastRobotStatusCode.REQUIRE_USER_ATTENTION));
    }

    if (isTouchProbeExpandedResponse === shouldTouchProbeExpanded || shouldTouchProbeExpanded === null) {
      if (callback) callback();
    }
  };

// #endregion touch probe

export function showReuseTipsModal(callback, {isEnabledCase = true} = {}) {
  const messageId = isEnabledCase ? 'modal.reuseTip.enabled.text' : 'modal.reuseTip.disabled.text';

  return (dispatch) => {
    dispatch(
      showModal(
        intl.formatMessage({
          id: 'modal.reuseTip.title',
        }),
        <FormattedHTMLMessage id={messageId} />,
        [
          {
            className: 'btn-lg',
            style: 'secondary',
            handlerClick: () => {
              dispatch(hideModal());
            },
            text: intl.formatMessage({
              id: 'modal.reuseTip.firstButton',
            }),
          },
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: () => {
              dispatch(hideModal());
              callback();
            },
            text: intl.formatMessage({
              id: 'modal.reuseTip.secondButton',
            }),
          },
        ],
        () => {
          dispatch(hideModal());
        },
        '',
        false,
      ),
    );
  };
}

export function showImportUnknownPlateId() {
  return (dispatch) => {
    dispatch(
      showModal(
        intl.formatMessage({id: 'explorer.explorerMenuBarContainer.uploadProtocol.title'}),
        intl.formatMessage({id: 'explorer.explorerMenuBarContainer.uploadProtocol.fail.unknownPlateId'}),
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: () => {
              dispatch(hideModal());
            },
            text: intl.formatMessage({id: 'explorer.explorerMenuBarContainer.uploadProtocol.fail.closeButton'}),
          },
        ],
        () => dispatch(hideModal()),
      ),
    );
  };
}

export function showModalMotorCollisionSkipped(actionCallback1) {
  return async (dispatch) => {
    const {arrayErrorMotorName, isCollision, isSkipMustReleaseTip} = await dispatch(getMotorError());

    dispatch(
      showModal(
        intl.formatMessage({id: `modal.motorCollisionSkipped.title.${isCollision ? 'collision' : 'skipped'}`}),
        <FormattedHTMLMessage
          id={`modal.motorCollisionSkipped.text.${isCollision ? 'collision' : 'skipped'}`}
          values={{trayMotors: arrayErrorMotorName.map((e) => `${e} motor`).join(', ')}}
        />,
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: async () => {
              await dispatch(hideModal());
              actionCallback1(isSkipMustReleaseTip);
            },
            text: intl.formatMessage({id: 'modal.motorCollisionSkipped.firstButton'}),
          },
        ],
        () => dispatch(hideModal()),
        'motorSkippedModal',
        true,
      ),
    );
  };
}

export const getMotorError = () => async (dispatch) => {
  const arrayErrorMotorName = [];
  let isCollision = false;
  let isSkipMustReleaseTip = false;

  await dispatch(getAllMotorStatus()).then((motorStatus) => {
    if (motorStatus) {
      for (let index = 0; index < motorStatus.length; index += 1) {
        const motoSts = motorStatus[index].split(', ');
        for (let i = 0; i < motoSts.length; i += 1) {
          if (GetAllMotorStatusMotorErrorStatus.includes(motoSts[i])) {
            arrayErrorMotorName.push(MotorName[index]);

            // skipped on Plunger, Plunger Clamp, Tip Clamp motor must release tip
            if (index > 2) {
              isSkipMustReleaseTip = true;
            }
          }
          isCollision = isCollision || motoSts[i] === 'aborted';
        }
      }
    }
  });

  return {arrayErrorMotorName, isCollision, isSkipMustReleaseTip};
};

export const showMotorSkipModal = (callback) => async (dispatch) => {
  const {arrayErrorMotorName} = await dispatch(getMotorError());

  dispatch(
    showModal(
      intl.formatMessage({id: 'modal.motorCollisionSkipped.title.skipped'}),
      <FormattedHTMLMessage
        id="modal.motorCollisionSkipped.text.skipped"
        values={{trayMotors: arrayErrorMotorName.map((e) => `${e} motor`).join(', ')}}
      />,

      getMessageBoxActionButtons([
        {
          type: MessageBox.ButtonType.POSITIVE,
          text: intl.formatMessage({id: 'modal.motorCollisionSkipped.firstButton'}),
          clickHandler: async () => {
            dispatch(hideModal());
            await dispatch(callback());
          },
        },
      ]),
      () => {
        dispatch(hideModal());
      },
      '',
      true,
    ),
  );
};

export function showModalMotorIssueOccurs(errorCode, actionCallback1, actionCallback2) {
  return async (dispatch, getState) => {
    const {runtimeState} = getState();
    const {status} = runtimeState;

    const resumeButton = {
      className: 'btn-lg',
      style: 'primary',
      handlerClick: async () => {
        dispatch(hideModal());
        actionCallback1();
      },
      text: intl.formatMessage({id: 'modal.motorIssueOccurs.firstButton'}),
    };

    const abortButton = {
      className: 'btn-lg',
      style: 'secondary',
      handlerClick: async () => {
        dispatch(hideModal());
        actionCallback2();
      },
      text: intl.formatMessage({id: 'modal.motorIssueOccurs.secondButton'}),
    };

    const buttons = status === RuntimeMode.ABORTED ? [abortButton] : [resumeButton, abortButton];

    dispatch(
      showModal(
        intl.formatMessage({id: 'modal.motorIssueOccurs.title'}),
        <FormattedHTMLMessage id="modal.motorIssueOccurs.text" values={{errorCode}} />,
        buttons,
        () => dispatch(hideModal()),
        'motorSkippedModal',
        true,
      ),
    );
  };
}

// #region runtime

export const showNoRunningProtocolModal = () => (dispatch) => {
  dispatch(
    showModal(
      intl.formatMessage({
        id: 'runtime.noRunningProtocolModal.title',
      }),
      <FormattedHTMLMessage id="runtime.noRunningProtocolModal.content" />,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
          },
          text: intl.formatMessage({
            id: 'runtime.noRunningProtocolModal.okButton',
          }),
        },
      ],
      () => {
        dispatch(hideModal());
      },
      'no-running-protocol-modal',
      false,
    ),
  );
};

/**
 * Modal to show remove labware confirmation when the touch probe is extended
 * @param {Function} callback
 * @param {String} type event type
 * @param {Boolean} isShowCloseButton
 */
export const showModalAutoCalibrationConfirmation =
  (
    // eslint-disable-next-line default-param-last
    callback = () => {},
    type,
    isShowCloseButton = true,
  ) =>
  async (dispatch) => {
    let idText = 'trayCalibrationContainer.modal.removeObjectConfirmation.text.calibration';
    if (type === SignalREvent.SAFE_TOUCH_PROBE_EXTEND) {
      idText = 'trayCalibrationContainer.modal.removeObjectConfirmation.text.touchProbeExtend';
    } else if (type === SignalREvent.SAFE_TOUCH_PROBE_RETRACT) {
      idText = 'trayCalibrationContainer.modal.removeObjectConfirmation.text.touchProbeRetract';
    }

    const getContent = (isChecked) => {
      const onChangeHandler = (e) => {
        dispatch(setModalContent(getContent(e.target.checked)));

        if (e.target.checked) {
          dispatch(setModalValid());
        } else {
          dispatch(setModalInvalid());
        }
      };

      return (
        <div>
          <span style={{lineHeight: '2em'}}>
            <FormattedHTMLMessage id={idText} />
          </span>
          <br />
          <FmlxCheckBox
            onChange={onChangeHandler}
            label={intl.formatMessage({
              id: 'trayCalibrationContainer.modal.removeObjectConfirmation.labelCheckBox',
            })}
            checked={isChecked}
          />
        </div>
      );
    };

    dispatch(setModalInvalid());
    dispatch(
      showModal(
        intl.formatMessage({
          id: 'trayCalibrationContainer.modal.removeObjectConfirmation.title',
        }),
        getContent(false),
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: async () => {
              dispatch(hideModal());
              callback();
            },
            text: intl.formatMessage({
              id: 'trayCalibrationContainer.modal.removeObjectConfirmation.firstButton',
            }),
          },
        ],
        () => {
          dispatch(setModalValid());
          dispatch(hideModal());
        },
        '',
        !isShowCloseButton,
      ),
    );
  };

// #endregion

// #region updater

export const showFailedToUpdateSystemModal = (successCallback, cancelCallback) => async (dispatch) => {
  await dispatch(setErrorCodeNumber(FastRobotErrorcode.UPDATE_INTERNAL_ERROR));
  dispatch(
    showModal(
      intl.formatMessage({id: 'modal.failedToUpdateSystem.title'}),
      <div className="modal-failed-to-update__text">
        <FormattedHTMLMessage id="modal.failedToUpdateSystem.warningMessage" />
      </div>,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            if (successCallback) {
              successCallback();
            }
          },
          text: intl.formatMessage({id: 'modal.failedToUpdateSystem.firstButton'}),
        },
        {
          className: 'btn-lg',
          style: 'secondary',
          handlerClick: () => {
            dispatch(hideModal());
            if (cancelCallback) cancelCallback();
          },
          text: intl.formatMessage({id: 'modal.failedToUpdateSystem.secondButton'}),
        },
      ],
      () => {
        dispatch(hideModal());
      },
      'modal-failed-to-update',
      true,
    ),
  );
};

export const showFailedToDowngradeSystemModal = () => (dispatch) => {
  dispatch(
    showModal(
      intl.formatMessage({id: 'modal.failedToDowngradeSystem.title'}),
      <FormattedHTMLMessage id="modal.failedToDowngradeSystem.text" />,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
          },
          text: intl.formatMessage({id: 'modal.failedToDowngradeSystem.button'}),
        },
      ],
      () => {
        dispatch(hideModal());
      },
      'modal-failed-to-update',
      true,
    ),
  );
};

// #endregion updater

// #region licensing
export const noLicenseActivatedModal = () => (dispatch) => {
  const isOperator = dispatch(isUserOperator());
  dispatch(
    showModal(
      intl.formatMessage({id: 'licensing.modal.licenseActivation.noLicenseActivated.title'}),
      <div className="modal-failed-to-update__text">
        {intl.formatMessage({id: 'licensing.modal.licenseActivation.noLicenseActivated.text'})}
      </div>,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          disabled: isOperator,
          handlerClick: async () => {
            await dispatch(hideModal());
            dispatch(showLicenseModal());
          },
          text: intl.formatMessage({id: 'licensing.modal.licenseActivation.noLicenseActivated.firstButton'}),
        },
        {
          className: 'btn-lg',
          style: 'secondary',
          handlerClick: async () => {
            await dispatch(getLicenseData());
            await dispatch(hideModal());
          },
          text: intl.formatMessage({id: 'licensing.modal.licenseActivation.noLicenseActivated.secondButton'}),
        },
      ],
      null,
      'modal-failed-to-update',
      true,
    ),
  );
};

// #endregion licensing

export const showTipClampCounterWarningModal = (callback) => async (dispatch) => {
  const tipClampConfig = await dispatch(getMaxTipClampConfig());
  const statistic = await dispatch(getTipClampStatistic());

  const {tipClampAttachNotificationThreshold, headLifetimeNotificationThreshold} = tipClampConfig;
  const {tipClampAttachCounter, tipClampFullyReleaseCounter, headLifetime} = statistic;
  const isHeadCyclesLimitReached = headLifetime >= headLifetimeNotificationThreshold;

  if (
    tipClampAttachCounter + tipClampFullyReleaseCounter < tipClampAttachNotificationThreshold &&
    !isHeadCyclesLimitReached
  ) {
    callback();
    return;
  }

  dispatch(
    showModal(
      intl.formatMessage({
        id: isHeadCyclesLimitReached
          ? 'modal.headCounterWarningModal.title'
          : 'modal.tipClampCounterWarningModal.title',
      }),
      <FormattedHTMLMessage
        id={isHeadCyclesLimitReached ? 'modal.headCounterWarningModal.text' : 'modal.tipClampCounterWarningModal.text'}
        values={{
          notificationThreshold: isHeadCyclesLimitReached
            ? headLifetimeNotificationThreshold.toLocaleString()
            : tipClampAttachNotificationThreshold.toLocaleString(),
        }}
      />,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            callback();
          },
          text: intl.formatMessage({
            id: isHeadCyclesLimitReached
              ? 'modal.headCounterWarningModal.firstButton'
              : 'modal.tipClampCounterWarningModal.firstButton',
          }),
        },
      ],
      () => dispatch(hideModal()),
      '',
      true,
    ),
  );
};

// #region auto calibration

export const showAbnormalCalibrationDataModal = (firstButtonCallback, secondButtonCallback) => (dispatch) => {
  dispatch(
    showModal(
      intl.formatMessage({
        id: 'modal.abnormalTrayCalibrationData.title',
      }),
      <FormattedHTMLMessage id="modal.abnormalTrayCalibrationData.text" />,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            firstButtonCallback();
          },
          text: intl.formatMessage({
            id: 'modal.abnormalTrayCalibrationData.firstButton',
          }),
        },
        {
          className: 'btn-lg',
          style: 'secondary',
          handlerClick: () => {
            dispatch(hideModal());
            secondButtonCallback();
          },
          text: intl.formatMessage({
            id: 'modal.abnormalTrayCalibrationData.secondButton',
          }),
        },
      ],
      () => {},
      'scan-fail-modal',
      true,
    ),
  );
};

export const showFailedToRunCalibrationModal = (rollPitchYaw, thresholdRPY) => async (dispatch) => {
  await dispatch(setErrorCodeNumber(FastRobotErrorcode.MISALIGNMENT_TRAY));

  if (
    Math.abs(rollPitchYaw.x) > thresholdRPY.x ||
    Math.abs(rollPitchYaw.y) > thresholdRPY.y ||
    Math.abs(rollPitchYaw.z) > thresholdRPY.z
  ) {
    dispatch(
      showModal(
        intl.formatMessage({
          id: 'trayCalibrationContainer.modal.failedToRunCalibration.title',
        }),
        <FormattedHTMLMessage id="trayCalibrationContainer.modal.failedToRunCalibration.text" />,
        [
          {
            className: 'btn-lg',
            style: 'primary',
            handlerClick: () => {
              dispatch(hideModal());
            },
            text: intl.formatMessage({
              id: 'trayCalibrationContainer.modal.failedToRunCalibration.firstButton',
            }),
          },
        ],
        () => dispatch(hideModal()),
        '',
        true,
      ),
    );
  }
};

export const showModalTrayIdPositionNotFoundSetupWizard =
  (successCallback, alternateCallback, isAfterSettingCalibrationData) => async (dispatch) => {
    const isUsingV2Instrument = isV2Instrument();
    let calibrationName;

    if (isUsingV2Instrument) {
      calibrationName = parseMessage('modal.setupWizard.trayBarcodeNotFound.calibrationName.tipsPickup');
    } else {
      calibrationName = parseMessage('modal.setupWizard.trayBarcodeNotFound.calibrationName.a1Offset');
    }

    const title = isAfterSettingCalibrationData
      ? parseMessage('modal.setupWizard.trayBarcodeNotFoundAfterA1.title')
      : parseMessage('modal.setupWizard.trayBarcodeNotFound.title');

    const body = isAfterSettingCalibrationData
      ? parseMessage('modal.setupWizard.trayBarcodeNotFoundAfterA1.text')
      : parseMessage('modal.setupWizard.trayBarcodeNotFound.text', {calibrationName});

    const buttons = [
      {
        label: parseMessage('modal.setupWizard.trayBarcodeNotFoundAfterA1.firstButton'),
        onClick: successCallback,
      },
      {
        label: parseMessage(CommonButtonLabel.IGNORE),
        onClick: alternateCallback,
      },
    ];

    dispatch(showModalSimplified(title, body, buttons));
  };

export const showModalTrayIdPositionNotFound = (callback1, callback2) => (dispatch, getState) => {
  const stepName = getStepNameSelector(getState());

  if (stepName === SetupWizardStep.A1_OFFSET_CALIBRATION || stepName === SetupWizardStep.TIPS_PICKUP_CALIBRATION) {
    const {currentSubstep} = dispatch(getSetupWizardCurrentStepData());
    const isAfterSettingCalibrationData = currentSubstep === A1OffsetCalibrationSubstep.CHECK_TIP_PICK_UP;

    dispatch(showModalTrayIdPositionNotFoundSetupWizard(callback1, callback2, isAfterSettingCalibrationData));
    return;
  }

  dispatch(
    showModal(
      intl.formatMessage({id: 'modal.trayIdPositionNotFound.title'}),
      <FormattedHTMLMessage id="modal.trayIdPositionNotFound.message" />,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            callback1();
          },
          text: intl.formatMessage({
            id: 'modal.trayIdPositionNotFound.firstButton',
          }),
        },
        {
          className: 'btn-lg',
          style: 'secondary',
          handlerClick: () => {
            dispatch(hideModal());
            callback2();
          },
          text: intl.formatMessage({
            id: 'modal.trayIdPositionNotFound.secondButton',
          }),
        },
      ],
      () => {},
      'scan-fail-modal',
      true,
    ),
  );
};

export const showModalProblemWithTheHardware = (errorCode, callback) => (dispatch) => {
  dispatch(
    showModal(
      intl.formatMessage({
        id: 'trayCalibrationContainer.modal.problemWithTheHardware.title',
      }),
      <FormattedHTMLMessage id="trayCalibrationContainer.modal.problemWithTheHardware.text" values={{errorCode}} />,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            callback();
          },
          text: intl.formatMessage({
            id: 'trayCalibrationContainer.modal.problemWithTheHardware.firstButton',
          }),
        },
      ],
      () => {},
      '',
      true,
    ),
  );
};

export const showSafetyThresholdExceededModal = () => (dispatch) => {
  dispatch(
    showModal(
      intl.formatMessage({
        id: 'trayCalibrationContainer.modal.trayYawExceeds.title',
      }),
      <FormattedHTMLMessage id="trayCalibrationContainer.modal.trayYawExceeds.text" />,
      [
        {
          className: 'btn-lg',
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
          },
          text: intl.formatMessage({
            id: 'trayCalibrationContainer.modal.trayYawExceeds.firstButton',
          }),
        },
      ],
      () => {},
      '',
      true,
    ),
  );
};

// #endregion auto calibration

export const showCommonVisionErrorModal =
  (
    // eslint-disable-next-line default-param-last
    values = {},
    retryCallback,
    abortCallback,
  ) =>
  (dispatch) => {
    const retryButton = {
      type: MessageBox.ButtonType.POSITIVE,
      text: intl.formatMessage({id: 'common.modal.action.retry'}),
      clickHandler: () => {
        dispatch(hideModal());
        retryCallback();
      },
    };

    const abortButton = {
      type: MessageBox.ButtonType.NEGATIVE,
      text: intl.formatMessage({id: 'common.modal.action.abort'}),
      clickHandler: () => {
        dispatch(hideModal());
        abortCallback();
      },
    };

    const buttons = getMessageBoxActionButtons([retryButton, abortButton]);

    dispatch(
      showModal(
        <FormattedHTMLMessage id="modal.visionDefaultError.title" />,
        <FormattedHTMLMessage id="modal.visionDefaultError.message.common" values={{...values}} />,
        buttons,
        () => dispatch(hideModal()),
        '',
        true,
      ),
    );
  };

export const showCaddyErrorModal =
  (
    // eslint-disable-next-line default-param-last
    values = {},
    retryCallback,
    abortCallback,
  ) =>
  (dispatch) => {
    const retryButton = {
      type: MessageBox.ButtonType.POSITIVE,
      text: intl.formatMessage({id: 'common.modal.action.retry'}),
      clickHandler: () => {
        dispatch(hideModal());
        retryCallback();
      },
    };

    const abortButton = {
      type: MessageBox.ButtonType.NEGATIVE,
      text: intl.formatMessage({id: 'common.modal.action.abort'}),
      clickHandler: () => {
        dispatch(hideModal());
        abortCallback();
      },
    };

    const buttons = getMessageBoxActionButtons([retryButton, abortButton]);

    dispatch(
      showModal(
        <FormattedHTMLMessage id="modal.caddyNotFound.title" />,
        <FormattedHTMLMessage id="modal.caddyNotFound.message.tray2" values={{...values}} />,
        buttons,
        () => dispatch(hideModal()),
        '',
        true,
      ),
    );
  };

export const showTipsNotEnoughModal =
  (
    // eslint-disable-next-line default-param-last
    values = {},
    retryCallback,
    abortCallback,
  ) =>
  (dispatch) => {
    const retryButton = {
      type: MessageBox.ButtonType.POSITIVE,
      text: intl.formatMessage({
        id: 'plateTypeEditorContainer.modal.manualReteachPlate.tipsNotEnoughMessageModal.firstButton',
      }),
      clickHandler: () => {
        dispatch(hideModal());
        retryCallback();
      },
    };

    const abortButton = {
      type: MessageBox.ButtonType.NEGATIVE,
      text: intl.formatMessage({
        id: 'plateTypeEditorContainer.modal.manualReteachPlate.tipsNotEnoughMessageModal.secondButton',
      }),
      clickHandler: () => {
        dispatch(hideModal());
        abortCallback();
      },
    };

    const buttons = getMessageBoxActionButtons([retryButton, abortButton]);

    dispatch(
      showModal(
        <FormattedHTMLMessage id="plateTypeEditorContainer.modal.manualReteachPlate.tipsNotEnoughMessageModal.title" />,
        <FormattedHTMLMessage
          id="plateTypeEditorContainer.modal.manualReteachPlate.tipsNotEnoughMessageModal.message"
          values={{...values}}
        />,
        buttons,
        () => dispatch(hideModal()),
        '',
        true,
      ),
    );
  };

export const showFallenTipErrorModal =
  (
    // eslint-disable-next-line default-param-last
    values = {},
    retryCallback,
    abortCallback,
    ignoreCallback,
  ) =>
  (dispatch, getState) => {
    const {
      appState: {viewMode},
      reteachPlateState: {manualReteachPlate: currentInfo},
    } = getState();
    let isManualReteachPlate = false;

    if (viewMode === ViewMode.PLATE_TYPE_EDITOR && !isEmpty(currentInfo)) {
      isManualReteachPlate = true;
    }
    const retryButton = {
      type: MessageBox.ButtonType.POSITIVE,
      text: intl.formatMessage({id: 'common.modal.action.retry'}),
      clickHandler: () => {
        dispatch(hideModal());
        retryCallback();
      },
    };

    const ignoreButton = {
      type: MessageBox.ButtonType.NEGATIVE,
      text: intl.formatMessage({id: 'common.modal.action.ignore'}),
      clickHandler: () => {
        dispatch(hideModal());
        ignoreCallback();
      },
    };

    const abortButton = {
      type: MessageBox.ButtonType.NEGATIVE,
      text: intl.formatMessage({id: 'common.modal.action.abort'}),
      clickHandler: () => {
        dispatch(hideModal());
        abortCallback();
      },
    };

    const buttons = getMessageBoxActionButtons([retryButton, ignoreButton, abortButton]);

    dispatch(
      showModal(
        <FormattedHTMLMessage id="modal.tipFallen.title" />,
        <FormattedHTMLMessage
          id={isManualReteachPlate ? 'modal.tipFallen.manualPlateDefinition.message' : 'modal.tipFallen.message'}
          values={{...values}}
        />,
        buttons,
        () => dispatch(hideModal()),
        '',
        true,
      ),
    );
  };

export const showStuckTipModal = (callback) => (dispatch) => {
  dispatch(
    showModal(
      <FormattedHTMLMessage id="modal.tipStuck.title" />,
      <FormattedHTMLMessage id="modal.tipStuck.message" />,
      [
        {
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            if (callback) callback();
          },
          text: intl.formatMessage({id: CommonButtonLabel.GOT_IT}),
        },
      ],
    ),
  );
};

export const showErrorMissingTrayModal = (callback) => (dispatch) => {
  dispatch(
    showModal(
      <FormattedHTMLMessage id="modal.missingTray.title" />,
      <FormattedHTMLMessage id="modal.missingTray.idle.text" />,
      [
        {
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            if (callback) callback();
          },
          text: intl.formatMessage({id: CommonButtonLabel.GOT_IT}),
        },
      ],
    ),
  );
};

export const showTrayNotDetectedModal = (callback) => (dispatch) => {
  dispatch(
    showModal(
      <FormattedHTMLMessage id="modal.trayNotDetected.title" />,
      <FormattedHTMLMessage id="modal.trayNotDetected.text" />,
      [
        {
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            if (callback) callback();
          },
          text: intl.formatMessage({id: 'modal.trayNotDetected.button'}),
        },
      ],
    ),
  );
};

export const showFolderUpdatedModal = (callback) => (dispatch) => {
  dispatch(
    showModal(
      <FormattedHTMLMessage id="modal.operator.folderUpdated.title" />,
      <FormattedHTMLMessage id="modal.operator.folderUpdated.text" />,
      [
        {
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            if (callback) callback();
          },
          text: intl.formatMessage({id: CommonButtonLabel.GOT_IT}),
        },
      ],
    ),
  );
};

export const showProtocolOrFolderNotAvailable = (callback) => (dispatch) => {
  dispatch(
    showModal(
      <FormattedHTMLMessage id="modal.operator.protocolOrFolderNotAvailable.title" />,
      <FormattedHTMLMessage id="modal.operator.protocolOrFolderNotAvailable.text" />,
      [
        {
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            if (callback) callback();
          },
          text: intl.formatMessage({id: CommonButtonLabel.GOT_IT}),
        },
      ],
    ),
  );
};

export const showFolderHasTessaraProtocol = (callback) => (dispatch) => {
  dispatch(
    showModal(
      <FormattedHTMLMessage id="modal.operator.folderHasTessaraProtocol.title" />,
      <FormattedHTMLMessage id="modal.operator.folderHasTessaraProtocol.text" />,
      [
        {
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            if (callback) callback();
          },
          text: intl.formatMessage({id: CommonButtonLabel.CONFIRM}),
        },
        {
          style: 'secondary',
          handlerClick: () => {
            dispatch(hideModal());
          },
          text: intl.formatMessage({id: CommonButtonLabel.CANCEL}),
        },
      ],
    ),
  );
};

export const showSelectedProtocolHasTessaraProtocolOnDropOnSharedFolder = (callback) => (dispatch) => {
  dispatch(
    showModal(
      intl.formatMessage({
        id: 'explorer.moveProtocols.tessaraProtocolMoveModal.title',
      }),
      intl.formatMessage({
        id: 'explorer.moveProtocols.tessaraProtocolMoveModal.text',
      }),
      [
        {
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
            if (callback) callback();
          },
          text: intl.formatMessage({
            id: CommonButtonLabel.CONFIRM,
          }),
        },
        {
          style: 'secondary',
          handlerClick: () => {
            dispatch(hideModal());
          },
          text: intl.formatMessage({
            id: CommonButtonLabel.CANCEL,
          }),
        },
      ],
    ),
  );
};

export const showPlateIsNotEditableModal = () => (dispatch) => {
  dispatch(
    showModal(
      <FormattedHTMLMessage id="modal.plateIsNotEditable.title" />,
      <FormattedHTMLMessage id="modal.plateIsNotEditable.text" />,
      [
        {
          style: 'primary',
          handlerClick: () => {
            dispatch(hideModal());
          },
          text: intl.formatMessage({id: CommonButtonLabel.GOT_IT}),
        },
      ],
      () => dispatch(hideModal()),
      '',
      false,
    ),
  );
};
